import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  private openModalSubject = new Subject<void>();
  openModal$ = this.openModalSubject.asObservable();

  openModal() {
    console.debug('AnnouncementService.openModal() called');
    setTimeout(() => {
      this.openModalSubject.next();
    }, 0);
  }
}
